// src/services/api.js
import axios from 'axios';
import { APP_BUILD, APP_BUILD_HEADER } from '../utils/appBuild';

// Use environment variable for API URL or fallback to same origin in production
const baseURL = process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:5000'
    : window.location.origin);

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    [APP_BUILD_HEADER]: APP_BUILD,
  }
});

// Log the API configuration
console.log('API Service initialized with baseURL:', baseURL);

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // The server-side subscription gate (server/middleware/
    // subscriptionGate.js) answers a lapsed provider's writes with 402.
    // The App already routes them to billing on load; this catches the
    // case where the subscription lapsed mid-session.
    if (error.response?.status === 402 && error.response?.data?.code === 'subscription_required') {
      if (typeof window !== 'undefined' && window.location.pathname !== '/provider/billing') {
        window.location.href = '/provider/billing';
      }
      return Promise.reject(error);
    }
    if (error.response?.status === 401) {
      // Public / anon routes are explicitly meant to run without a
      // session — the wizard on /p/:joinCode/book uses the auth
      // wizard's UI in anon mode; some of its `api.` calls WILL 401
      // because they hit provider-scoped endpoints. Bouncing the
      // visitor to /login there would break the intended flow.
      // Same rationale for the public provider profile itself, the
      // claim-account handoff, and the receipt viewer.
      const path = typeof window !== 'undefined' ? window.location.pathname : '';
      const isPublicRoute =
        path.startsWith('/p/') ||
        path.startsWith('/claim/') ||
        path.startsWith('/receipt/') ||
        path === '/login' ||
        path === '/register';
      if (!isPublicRoute) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
